export const DEFAULT_MIN_QUANTITY = process.env.FRONTEND_ENV === 'production' ? 25 : 3;

export const SHIPPING_METHOD = {
    CSV_LIST: 'csv_list',
    LOCATION_ADDRESS: 'location_address',
    SELF_PRINTABLE: 'self_printable',
};

export const CREATE_NEW_VALUE = 'create_new';

export const WIZARD_STEP = {
    CONTACT: 1,
    SHIPPING: 2,
    CUSTOMIZE: 3,
    REVIEW: 4,
    THANK_YOU: 5,
};

/**
 * Resolves a category name from an item, category object, or string.
 * @param {object|string} itemOrName
 * @returns {string}
 */
export const categoryName = (itemOrName) => {
    if (typeof itemOrName === 'string') {
        return itemOrName;
    }
    return itemOrName?.category_name || itemOrName?.category?.name || '';
};

export const isBrochure = (item) => categoryName(item).toLowerCase().includes('brochure');
export const isPostcard = (item) => categoryName(item).toLowerCase().includes('postcard');
export const isQuoteLetter = (item) => categoryName(item).toLowerCase().includes('quote letter');
export const isSwag = (item) => categoryName(item).toLowerCase().includes('swag');
export const isClip = (item) => isSwag(item) && item.swag_type === 'clip';
export const isBallpointPen = (item) => isSwag(item) && item.swag_type === 'ballpoint_pen';

export const getFrontPreviewUrl = (item) =>
    item.front_preview_source || item.data?.image?.preview_source || item.data?.image?.source || item.front_preview_url;

export const getBackPreviewUrl = (item) =>
    item.back_preview_source || item.data?.second_image?.preview_source || item.data?.second_image?.source || item.back_preview_url;

/**
 * Gets the minimum quantity required for a collateral item.
 * @param {object} item - The collateral request item.
 * @returns {number} The minimum quantity.
 */
export const getMinQuantity = (item) => {
    return isSwag(item) && item?.min_quantity ? item?.min_quantity : DEFAULT_MIN_QUANTITY;
};
